export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["номер"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ім'я"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Скасування"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Зберегти"])}
}